import React from 'react';

const Card = ({title, children}) => {
    return ( 
        <div className="border-solid border my-4 py-3 px-2">
        <div className='border-solid border-b mb-2 pb-2 px-1 font-bold'>
            {title}
        </div>
        <div className='px-4'>
            {children}
        </div>
    </div>
);
}
 
export default Card;